export type HolidayPreview = "christmas" | "new_year" | "valentine" | "halloween" | "off" | null;

export const HOLIDAY_PREVIEW_STORAGE_KEY = "ck-holiday-preview";

export function parseHolidayPreviewParam(value: string | null): HolidayPreview | undefined {
  if (!value) return undefined;
  const v = value.trim().toLowerCase();
  if (v === "christmas" || v === "xmas") return "christmas";
  if (v === "newyear" || v === "new_year" || v === "nye") return "new_year";
  if (v === "valentine" || v === "valentines" || v === "vday") return "valentine";
  if (v === "halloween" || v === "spooky" || v === "hween") return "halloween";
  if (v === "off" || v === "none") return "off";
  if (v === "clear" || v === "reset") return null;
  return undefined;
}

export function readStoredHolidayPreview(): HolidayPreview {
  try {
    const v = sessionStorage.getItem(HOLIDAY_PREVIEW_STORAGE_KEY);
    if (v === "christmas" || v === "new_year" || v === "valentine" || v === "halloween" || v === "off") return v;
  } catch {
    /* private mode */
  }
  return null;
}

export function writeStoredHolidayPreview(value: HolidayPreview) {
  try {
    if (!value) sessionStorage.removeItem(HOLIDAY_PREVIEW_STORAGE_KEY);
    else sessionStorage.setItem(HOLIDAY_PREVIEW_STORAGE_KEY, value);
  } catch {
    /* private mode */
  }
}
